import {useWebRTCSupport} from "@hooks/WebRTCSupport";
import warningImage from "@images/popups/error-upload.svg";
import {usePopup} from "@layouts/popup/InfoPopup/PopupContext";
import {WebRTCSupportPopup} from "@popups/simulationPopups/WebRTCSupportPopup";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {SmallDesc} from "@ui/descriptions/SmallDesc";
import {BorderArticle} from "@ui/general/BorderArticle";
import moment from "moment/min/moment-with-locales";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import styles from "./styles.module.scss";

export const PreviewCard = (props) => {
  const {
    name,
    image,
    due_date,
    finish_date,
    mandatory,
    mask,
    levelList,
    id,
    // trainingLimit,
    certified,
    isBig = false,
    asButton = false,
  } = props;

  const {openPopup} = usePopup();
  const navigate = useNavigate();
  const {t} = useTranslation();
  const {isWebRTCSupported, errorMessage} = useWebRTCSupport();
  const {isMobile} = useSelector((state) => state.common.settings);

  const isDueDateApproaching = (days) => {
    if (due_date || finish_date) {
      const now = moment();
      const dueDate = moment(due_date || finish_date);
      const diffDays = dueDate.diff(now, "days");

      return diffDays < days;
    }

    return false;
  };

  const isDueDatePassed = (date) => {
    if (!date) {
      return false;
    }

    const now = moment();
    const dueDate = moment(date);
    const diffDays = dueDate.diff(now, "days");

    return diffDays < -14;
  };

  const handleClickLevel = async (item, id) => {
    if (!isWebRTCSupported) {
      openPopup(
        <WebRTCSupportPopup
          errorMessage={errorMessage}
          close={() =>
            navigate(`/chat/${item.type}/${item.value}/${id}`, {
              state: {
                level: item,
                desc: {type: item.type, name, level: item.value},
              },
            })
          }
        />,
      );
    } else {
      navigate(`/chat/${item.type}/${item.value}/${id}`, {
        state: {
          level: item,
          desc: {type: item.type, name, level: item.value},
        },
      });
    }
  };

  if (!isDueDatePassed(due_date || finish_date)) {
    return (
      <div className={"relative z-[1]"}>
        <BorderArticle>
          <div
            style={
              isBig
                ? {
                    width: !isMobile ? "550rem" : "",
                    maxWidth: !isMobile ? "" : "400rem",
                    height: !isMobile ? "300rem" : "200rem",
                  }
                : {}
            }
            className={[
              styles.card,
              isDueDateApproaching(0) ? styles.cardDisabled : "",
              asButton ? styles.cardButton : "",
            ]
              .filter(Boolean)
              .join(" ")}
            onClick={
              asButton && !isDueDateApproaching(0)
                ? () => handleClickLevel(levelList?.[0], id)
                : undefined
            }
          >
            {image && (
              <img
                className={styles.cardPreview}
                src={image}
                alt={"preview-image"}
              />
            )}

            {mask && (
              <div
                className={styles.maskPreview}
                style={{background: `var(--${mask})`}}
              />
            )}

            <div className={styles.cardHeadWrapper}>
              {isDueDateApproaching(14) && (
                <div className={styles.cardHead}>
                  {(mandatory || finish_date) && (
                    <img
                      src={warningImage}
                      alt={"warning"}
                    />
                  )}

                  {(due_date || finish_date) && (
                    <SmallDesc>
                      <span>
                        {t("preview_card.date")}{" "}
                        <b>
                          {moment(due_date || finish_date).format("DD.MM.YYYY")}
                        </b>
                      </span>
                    </SmallDesc>
                  )}
                </div>
              )}

              {/* {trainingLimit && !isMobile && (
                <div className={styles.cardHeadInfo}>
                  <SmallDesc>
                    <span>{t("preview_card.available")}</span>
                    <b>
                      {isDueDateApproaching(0)
                        ? t("preview_card.available_false")
                        : t("preview_card.available_true")}
                    </b>
                  </SmallDesc>
                </div>
              )} */}

              {isBig && (
                <div className={styles.cardHeadInfo}>
                  <SmallDesc>
                    {/* <span>{t("preview_card.available")}</span> */}
                    <b>
                      {certified
                        ? t("page.dashboard.certification_status.passed")
                        : t("page.dashboard.certification_status.failed")}
                    </b>
                  </SmallDesc>
                </div>
              )}
            </div>

            {name && <h2 dangerouslySetInnerHTML={{__html: name}} />}

            {!asButton && levelList && (
              <ul
                className={styles.cardFooter}
                style={{
                  width: isBig ? "max-content" : "",
                  opacity: !certified ? 1 : 0.5,
                }}
              >
                {levelList.map((item) => (
                  <li
                    style={{
                      textAlign: isBig ? "center" : "",
                      pointerEvents: !certified ? "auto" : "none",
                    }}
                    key={item?.id}
                    onClick={() =>
                      isDueDateApproaching(0) || certified
                        ? undefined
                        : handleClickLevel(item, id)
                    }
                  >
                    <RootDesc>
                      <span>
                        <b dangerouslySetInnerHTML={{__html: item?.name}} />
                      </span>
                    </RootDesc>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </BorderArticle>
      </div>
    );
  } else return null;
};
